import useTranslation from 'next-translate/useTranslation';
import Text from '@atoms/Text/Text';
import Config from '@config';
import {
  StyledAddressChanger,
  StyledAddressChangerButton,
  StyledAddressChangerLeft,
  StyledInlineText,
} from '@molecules/SlotAddressChanger/SlotAddressChanger.styles';
import useCart from '@hooks/useCart';

interface Props {
  address: SlotAddress | null;
  changeDeliveryHandler?: () => void;
  disableChangeDeliveryMethod?: boolean;
}

const SlotAddressChanger = ({ address, changeDeliveryHandler, disableChangeDeliveryMethod }: Props) => {
  const { t } = useTranslation('deliverypicker');
  const DELIVERY_COPY = {
    [Config.HOME_DELIVERY]: t('deliveryPicker->addressChanger->deliverTo'),
    [Config.PICKUP_IN_STORE]: t('deliveryPicker->addressChanger->pickUpFrom'),
  };
  const { cart } = useCart();
  const deliveryCopy = DELIVERY_COPY[cart?.deliveryModeCode || ''];

  return (
    <StyledAddressChanger>
      <StyledAddressChangerLeft>
        <Text type="subhead" size="small" data-testid="addressChanger-line1">
          {`${deliveryCopy} `}
          <StyledInlineText data-hj-suppress="true">{address?.line1}</StyledInlineText>
        </Text>
        {address?.line2 && (
          <Text type="body" size="small" data-testid="addressChanger-line2">
            {address.line2}
          </Text>
        )}
      </StyledAddressChangerLeft>
      {!disableChangeDeliveryMethod && (
        <StyledAddressChangerButton type="button" onClick={changeDeliveryHandler}>
          {t('deliveryPicker->addressChanger->change')}
        </StyledAddressChangerButton>
      )}
    </StyledAddressChanger>
  );
};

export default SlotAddressChanger;
